import Dexie from 'dexie';
import { v4 as uuidV4 } from 'uuid';
import './iDBAddon';
export default class IDB extends Dexie {
  constructor(name, storeConfig, options) {
    options = { clearOfRebuild: true, maxUpdateTime: 2419200000, ...options, allowEmptyDB: true };
    super(name, options);
    this.__options = options;
    this.configDB(storeConfig);
  }

  configDB(storeConfig){
    if (!storeConfig){
      console.error('no table Stores');
      return;
    }
    Object.keys(storeConfig).forEach(
      version => {
        this.version(version).stores(storeConfig[version].stores);
      }
    );
  }

  /**
 * 设置数据库ID
 * @param id
 * @returns {Promise<ZKDexie>}
 */
  async setId(id) {
    await this.table('meta').put({ type: 'id', id });
    return this;
  }

  /**
   * 获取数据库ID
   * @returns {Promise<*|string>}
   */
  async getId() {
    const meta = await this.table('meta').get('id');
    if (meta?.id) {
      return meta.id;
    }
    const id = uuidV4();
    await this.setId(id);
    return id;
  }

  /**
 * 获取忽略清空表的数组（调用clear时会忽略该数组的表）
 * @returns {*|*[]}
 */
  get ignoreClearTables() {
    return this.__options.ignoreClearTables || [];
  }

  /**
   * 获取最后同步ID
   * @returns {Promise<(function(): Number)|number|number|*>}
  */
  async getLastSyncId() {
    const syncMeta = await this.table('meta').get('sync');
    return syncMeta?.lastSyncId || 0;
  }

  /**
 * 获取项目列表最后同步ID
 * @returns  {Promise<*|Object>}
 */
  async getlastProjectSync() {
    const syncMeta = await this.table('meta').get('sync');
    return syncMeta?.lastProjectSync || {};
  }

  /**
   * 清空数据库
   * @param options
   * @returns {Promise<void[]>}
   */
  clear(options) {
    const { clearId = false, clearSync = true } = options;
    const ignores = [ ...this.ignoreClearTables ];
    if (!clearId || !clearSync) {
      ignores.push('meta');
    }
    const ps = this.tables.filter(tb => !ignores.includes(tb.name)).map(tb => tb.clear());
    if (clearId && !clearSync) {
      ps.push(this.table('meta').delete('id'));
    }
    if (clearSync && !clearId) {
      ps.push(this.table('meta').delete('sync'));
    }
    return Promise.all(ps);
  }

  async asyncDBOperator(operator, options){
    try {
      return await operator(this);
    } catch (error) {
      return await this.handleError(options);
    }
  }

  async handleError(options){
    if (options?.errorCallback){
      return await options.errorCallback();
    }
  }

  destroy() {
    this.close();
    this.__options = {};
  }

}
